/**
 * @description
 */
import request from '@/utils/request'

/**
 * @description 用户登录验证
 */
export function login(data) {
  return request({
    url: `/admin/login`,
    data,
    method: 'post'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/admin/me',
    method: 'post'
  })
}




/**
 * @description 修改密码
 */
export function update_password(data) {
  return request({
    url: `/admin/update_password`,
    data,
    method: 'post'
  })
}

// 验证码
export function captcha(query) {
  return request({
    url: 'admin/captcha ',
    method: 'post',

  })
}